import React from "react";
import styles from "./Contact.module.css";
import { FiMail, FiPhone } from "react-icons/fi";
import { ImLinkedin } from "react-icons/im";
import { BsGithub } from "react-icons/bs";

const Contact = () => {
  return (
    <div>
      <h1 className={styles.heading}>Contact Me</h1>
      <div className={styles.mainBody}>
        <div className={styles.links}>
          <a href="mailto:aayyuusshh21@gmail.com" target="_blank">
            <FiMail
              style={{ color: "rgb(40, 158, 255)", marginRight: "1vw" }}
            />
            aayyuusshh21@gmail.com
          </a>
          <a
            href="https://www.linkedin.com/in/ayush-singh-023aa6159/"
            target="_blank"
          >
            <ImLinkedin
              style={{ color: "rgb(40, 158, 255)", marginRight: "1vw" }}
            />
            LinkedIn
          </a>
          <a
            href="https://github.com/aayyuusshh21"
            target="_b
          "
          >
            <BsGithub
              style={{ color: "rgb(40, 158, 255)", marginRight: "1vw" }}
            />
            GitHub
          </a>
          <a>
            <FiPhone
              style={{ color: "rgb(40, 158, 255)", marginRight: "1vw" }}
            />
            +91-9431516391{" "}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;

{
  /* <a href='mailto:xyz@yourapplicationdomain.com?subject=Me&body=Hello!'>EMAIL</a> */
}
